import backend from '@common/backend';

const BASE = '/services';

export interface IService {
	id: number;
	name: string;
}

export const getServices = async () => backend.get(`${BASE}`);
